var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c_event_cards c_wrapper"},_vm._l((_vm.events),function(event,index){return _c('EventCard',{key:index,attrs:{"event-type":event.eventType[0]?.title,"eyebrow-text":event.eyebrowText,"event-title":event.eventTitle,"event-image":[event.eventImage[0]?.filterLandscape],"event-description":event.eventDescription,"card-style":event.cardStyle,"primary-button":{
      primaryButtonAsset: event.primaryButtonAsset,
      primaryButtonEntry: event.primaryButtonEntry,
      primaryButtonCustomUrl: event.primaryButtonCustomUrl,
      primaryButtonText: event.primaryButtonText,
    },"secondary-button":{
      secondaryButtonAsset: event.secondaryButtonAsset,
      secondaryButtonEntry: event.secondaryButtonEntry,
      secondaryButtonCustomUrl: event.secondaryButtonCustomUrl,
      secondaryButtonText: event.secondaryButtonText,
    }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }